import React from 'react';
import Progress from './statistics/progress';
import Challenge from './statistics/challenge';
import RecentActivity from './statistics/recentactivity';
import '../styles/applayout.css';
import '../styles/mainpage.css';

interface Props {
  children: React.ReactNode;
  sidebar?: React.ReactNode;
  hideSidebarOnMobile?: boolean;
}

const AppLayout: React.FC<Props> = ({ children, sidebar, hideSidebarOnMobile }) => (
  <div className={`app-layout${hideSidebarOnMobile ? ' no-mobile-sidebar' : ''}`}>
    <div className="app-layout-content">
      {children}
    </div>
    <aside className="app-layout-sidebar">
      {sidebar ?? (
        <>
          <Progress />
          <Challenge />
          <RecentActivity />
        </>
      )}
    </aside>
  </div>
);

export default AppLayout;
